/* eslint-disable jira/filename-case */
import type { RouteResource } from '@atlassian/react-resource-router';

/**
 * SSR/AGG does not currently work for anonymous users and returns a 403.
 * This util mutates the provided resource so that the `getData` always returns null on SSR for anonymous users.
 * More info: https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
 */
export const withGiraAggAnonSsrFix = <T,>(resource: RouteResource<T>): RouteResource<T> => {
	if (!resource || !resource.getData) return resource;

	const originalGetData = resource.getData;
	// @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
	// oxlint-disable-next-line no-param-reassign
	resource.getData = (routerContext, customContext) => {
		if (__SERVER__ && customContext.tenantContext.isAnonymous) {
			return Promise.resolve(null);
		}
		return originalGetData(routerContext, customContext);
	};

	return resource;
};
